module.exports = __webpack_public_path__ + "img/Templates.5e48678d.svg";